import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useIntl from 'useIntl';
import { Icon, Badge } from 'mw-style-react';
import AppUtils from '@control-front-end/utils/utils';
import MenuItem from './components/MenuItem';
import UserProfile from './components/UserProfile';
import Account from './components/Account';
import Notifications from '../Notifications';
import Logo from './img/logo.svg';
import menu from './menu.json';
import { getActiveAccount } from '../../selectors';
import mes from './components/MenuItem/intl';
import './Menu.scss';

function Menu({ isSlideout }) {
  const t = useIntl();
  const [notify, setNotify] = useState(false);
  const wsNotify = useSelector((state) => state.wsNotify);
  const activeAccount = useSelector(getActiveAccount) || {};

  const getActiveMenu = () => {
    const menuList = [];
    menu.forEach((item) => {
      menuList.unshift(item);
      if (item.children.length) menuList.unshift(...item.children);
    });
    return menuList.find((item) => {
      const link = item.link.replace('{{accId}}', '(\\S+)');
      const re = new RegExp(link);
      return re.test(String(document.location.pathname));
    });
  };

  useEffect(() => {
    const activeMenu = getActiveMenu();
    if (activeMenu)
      document.title = `${t(mes[activeMenu.title])} - ${activeAccount.name}`;
  }, [document.location.href, activeAccount]);

  const renderNotifications = () => {
    if (!notify) return null;
    return <Notifications onClose={() => setNotify(false)} />;
  };

  const renderMenuItems = () => {
    const { id: accId, role } = activeAccount;
    return menu.map((item) => (
      <MenuItem
        key={item.id}
        accId={accId}
        role={role}
        menuItem={item}
        open={isSlideout}
      />
    ));
  };

  return (
    <div styleName="menu">
      <div styleName="menu__header">
        <div>
          <NavLink
            to={`${AppUtils.makeUrl(`/events/${activeAccount.id}/list`)}`}
          >
            <img alt="track" src={Logo} />
          </NavLink>
          <div
            styleName="menu__header__notify"
            onClick={() => setNotify(!notify)}
          >
            <Icon styleName="menu__header__notify__icon" type="notification" />
            {wsNotify.length ? (
              <Badge styleName="menu__header__notify__badge" />
            ) : null}
            <div styleName="menu__header__notify__items">
              {renderNotifications()}
            </div>
          </div>
        </div>
      </div>
      <div styleName="menu__content">{renderMenuItems()}</div>
      <div styleName="menu__footer">
        <div styleName="menu__footer__workspace">
          <Account />
        </div>
        <div styleName="menu__footer__profile">
          <div styleName="menu__footer__divider" />
          <UserProfile />
        </div>
      </div>
    </div>
  );
}

MenuItem.defaultProps = {
  isSlideout: false,
};

Menu.propTypes = {
  isSlideout: PropTypes.bool,
};

export default Menu;
